import { Redirect } from 'react-router-dom';
import { BILLING_USAGE_PATH } from '../subroutes';

export const BillingRootPage = () => {
  // For now, just redirect to usage
  return <Redirect to={BILLING_USAGE_PATH} />;
};
